import { UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ReleaseVersion } from '../types';
import { useRawReleaseVersions } from '../useReleaseVersions';
import { deduceLatestVersionAndSystemModel } from '../utils';

const useLatestVersion = (
  opts?: Omit<UseQueryOptions<ReleaseVersion[], AxiosError, ReleaseVersion>, 'queryKey' | 'queryFn'>
) => {
  return useRawReleaseVersions<ReleaseVersion>({
    select: deduceLatestVersionAndSystemModel,
    ...opts,
  });
};

export default useLatestVersion;
